import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  loadingContainer: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center'
  },
  contentContainer: {
    padding: theme.spacing(3)
  },
  headerSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  transcriptsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginTop: theme.spacing(4)
  },
  transcriptRow: {
    alignItems: 'baseline',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2)
  },
  callEndedContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4)
  }
}));
